import { useContext } from "react";
import { SlideOverContext } from "components/shared/slideOvers/SlideOverProvider/SlideOverProvider";

export const useSlideOver = () => {
  const context = useContext(SlideOverContext);
  if (context === undefined) {
    throw new Error("useSlideOver must be used within a SlideOverProvider");
  }
  return context;
};
